import {
  ApplicationState,
  ApplicationStateActionName,
  ApplicationStateActionTypes,
} from 'src/researcher/types/application';

export const InitApplicationState: ApplicationState = {
  totalStorageUsed: 0,
  saveFailedDueToStorage: false,
  singleDocumentSizeReached: false,
  onLine: true,
};

export function applicationStateReducer(
  state: ApplicationState = InitApplicationState,
  action: ApplicationStateActionTypes
): ApplicationState {
  switch (action.type) {
    case ApplicationStateActionName.SetOnLineStatus: {
      return {
        ...state,
        onLine: action.payload.onLine,
      };
    }
    case ApplicationStateActionName.SetTotalStorageUsed: {
      return {
        ...state,
        totalStorageUsed: action.payload.totalStorageUsed,
        saveFailedDueToStorage: false,
        singleDocumentSizeReached: false,
      };
    }
    case ApplicationStateActionName.SetSaveFailedDueToStorage: {
      return {
        ...state,
        saveFailedDueToStorage: action.payload.saveFailedDueToStorage,
        singleDocumentSizeReached: action.payload.singleDocumentSizeReached,
      };
    }
    default: {
      return state;
    }
  }
}
